module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('fieldset', {
    attrs: {
      "disabled": _vm.formDisabled
    }
  }, [_c('form', {
    staticClass: "form form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._l((_vm.attachmentList), function(attachment) {
    return _c('div', {
      key: attachment.index,
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-md-2 control-label"
    }, [_vm._v(_vm._s(attachment.description))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (attachment.view === 'optional' || _vm.adminProdEdit || _vm.qaqcEnabled),
        expression: "attachment.view === 'optional' || adminProdEdit || qaqcEnabled"
      }],
      staticClass: "col-md-4 form-inline"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (attachment.selectionId),
        expression: "attachment.selectionId"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(attachment, "selectionId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "disabled": "",
        "value": ""
      }
    }, [_vm._v("Select a value")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 1
      }
    }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 2
      }
    }, [_vm._v("No")])])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (attachment.view != 'optional' && !_vm.adminProdEdit && !_vm.qaqcEnabled),
        expression: "attachment.view != 'optional' && !adminProdEdit && !qaqcEnabled"
      }],
      staticClass: "col-md-2"
    }, [_c('label', {
      staticClass: "control-label"
    }, [_c('span', [_vm._v(_vm._s(attachment.view))])])]), _vm._v(" "), _c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (attachment.hasCount && (attachment.view !== 'not applicable' || _vm.adminProdEdit || _vm.qaqcEnabled)),
        expression: "attachment.hasCount && (attachment.view !== 'not applicable' || adminProdEdit || qaqcEnabled)"
      }],
      staticClass: "col-md-2 control-label"
    }, [_vm._v("Number of Attachments")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (attachment.hasCount && (attachment.view !== 'not applicable' || _vm.adminProdEdit || _vm.qaqcEnabled)),
        expression: "attachment.hasCount  && (attachment.view !== 'not applicable' || adminProdEdit || qaqcEnabled)"
      }],
      staticClass: "col-md-1"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (attachment.count),
        expression: "attachment.count"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "min": "0"
      },
      domProps: {
        "value": (attachment.count)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(attachment, "count", $event.target.value)
        }
      }
    })])])
  }), _vm._v(" "), (!(_vm.formDisabled)) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": _vm.saveAttachmentSelection
    }
  }, [_vm._v("Save")])])]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-offset",
    attrs: {
      "id": "attachments"
    }
  }, [_c('div', {
    staticClass: "panel-heading",
    class: _vm.qaqcEnabled ? 'qaqc-bg' : 'green-bg'
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Attachments")])]), _vm._v(" "), (_vm.attachmentSelection) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('tabs', [(_vm.attachmentSelection.hasPrehistoricArtifact) ? _c('tab', {
    attrs: {
      "header": "Prehistoric Artifacts"
    }
  }, [_c('prehistoricArtifactForm', {
    attrs: {
      "formDisabled": _vm.formDisabled,
      "qaqcEnabled": _vm.qaqcEnabled,
      "qaqcProgressDto": _vm.qaqcProgressDto,
      "saveQaqcProgress": _vm.saveQaqcProgress,
      "crrId": _vm.crrId
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.attachmentSelection.hasPrehistoricFeature) ? _c('tab', {
    attrs: {
      "header": "Prehistoric Features"
    }
  }, [_c('prehistoricFeatureForm', {
    attrs: {
      "formDisabled": _vm.formDisabled,
      "qaqcEnabled": _vm.qaqcEnabled,
      "qaqcProgressDto": _vm.qaqcProgressDto,
      "saveQaqcProgress": _vm.saveQaqcProgress,
      "crrId": _vm.crrId
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.attachmentSelection.hasHistoricArtifact) ? _c('tab', {
    attrs: {
      "header": "Historic Artifacts"
    }
  }, [_c('historicArtifactForm', {
    attrs: {
      "formDisabled": _vm.formDisabled,
      "qaqcEnabled": _vm.qaqcEnabled,
      "qaqcProgressDto": _vm.qaqcProgressDto,
      "saveQaqcProgress": _vm.saveQaqcProgress,
      "crrId": _vm.crrId
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.attachmentSelection.hasHistoricFeature) ? _c('tab', {
    attrs: {
      "header": "Historic Features"
    }
  }, [_c('historicFeatureForm', {
    attrs: {
      "formDisabled": _vm.formDisabled,
      "qaqcEnabled": _vm.qaqcEnabled,
      "qaqcProgressDto": _vm.qaqcProgressDto,
      "saveQaqcProgress": _vm.saveQaqcProgress,
      "crrId": _vm.crrId
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.attachmentSelection.hasRockArt && _vm.attachmentSelection.rockArtCount > 0) ? _c('tab', {
    attrs: {
      "header": "Rock Art"
    }
  }, [_c('rockArtForm', {
    attrs: {
      "rockArtCount": _vm.attachmentSelection.rockArtCount,
      "formDisabled": _vm.formDisabled,
      "qaqcEnabled": _vm.qaqcEnabled,
      "productionCrrId": _vm.productionCrrId,
      "qaqcProgressDto": _vm.qaqcProgressDto,
      "saveQaqcProgress": _vm.saveQaqcProgress,
      "crrId": _vm.crrId
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.attachmentSelection.hasHistoricBuilding && _vm.attachmentSelection.historicBuildingCount > 0) ? _c('tab', {
    attrs: {
      "header": "Historic Building"
    }
  }, [_c('historicBuildingForm', {
    attrs: {
      "attachmentCount": _vm.attachmentSelection.historicBuildingCount,
      "formDisabled": _vm.formDisabled,
      "qaqcEnabled": _vm.qaqcEnabled,
      "productionCrrId": _vm.productionCrrId,
      "qaqcProgressDto": _vm.qaqcProgressDto,
      "saveQaqcProgress": _vm.saveQaqcProgress,
      "crrId": _vm.crrId,
      "isSegment": !!_vm.culturalResource.segment,
      "projectId": _vm.projectId
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.attachmentSelection.hasLinearResource) ? _c('tab', {
    attrs: {
      "header": "Linear Resource"
    }
  }, [_c('linearResourceForm', {
    attrs: {
      "formDisabled": _vm.formDisabled,
      "qaqcEnabled": _vm.qaqcEnabled,
      "qaqcProgressDto": _vm.qaqcProgressDto,
      "saveQaqcProgress": _vm.saveQaqcProgress,
      "crrId": _vm.crrId
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.attachmentSelection.hasStructureObject && _vm.attachmentSelection.structureObjectCount > 0) ? _c('tab', {
    attrs: {
      "header": "Structure/Object"
    }
  }, [_c('structureObjectForm', {
    attrs: {
      "attachmentCount": _vm.attachmentSelection.structureObjectCount,
      "formDisabled": _vm.formDisabled,
      "qaqcEnabled": _vm.qaqcEnabled,
      "productionCrrId": _vm.productionCrrId,
      "qaqcProgressDto": _vm.qaqcProgressDto,
      "saveQaqcProgress": _vm.saveQaqcProgress,
      "crrId": _vm.crrId
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.attachmentSelection.hasUnknownFeature) ? _c('tab', {
    attrs: {
      "header": "Unknown Features"
    }
  }, [_c('unknownFeatureForm', {
    attrs: {
      "formDisabled": _vm.formDisabled,
      "qaqcEnabled": _vm.qaqcEnabled,
      "qaqcProgressDto": _vm.qaqcProgressDto,
      "saveQaqcProgress": _vm.saveQaqcProgress,
      "crrId": _vm.crrId
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b3c695a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteForm/Attachments.vue
// module id = 978
// module chunks = 1